// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 262) return "vendor-common.js";
	if (chunkId === 821) return "vendor-material-web.js";
	// return url for filenames based on template
	return "chunks/" + chunkId + ".js";
};